import { Dispatch, FC, SetStateAction, useState } from 'react'
import { useTranslation, UseTranslationResponse } from 'react-i18next'
import { FormControl, Select, MenuItem, Typography, Avatar, Box } from '@material-ui/core';
import ptBrLogo from 'assets/pt-br.svg'
import usLogo from 'assets/united-states.png'
import esLogo from 'assets/espanish.svg'
import amplitude from 'amplitude-js'

const LanguageSwitcher: FC = (): JSX.Element => {
  const { i18n }: UseTranslationResponse<"translation"> = useTranslation()
  const [language, setLanguage]: [string, Dispatch<SetStateAction<string>>] = useState<string>('pt-BR')
  const { t }: UseTranslationResponse<string> = useTranslation()

  const handleChange = (value: string) => {
    amplitude.getInstance().logEvent('A language_switch')
    setLanguage(value)
    i18n.changeLanguage(value)
  }
  return (

    <FormControl size="small" fullWidth variant="outlined">
      <Select
        style={{ background: '#fff' }}
        labelId="demo-simple-select-outlined-label"
        id="demo-simple-select-outlined"
        value={language}
        onChange={
          (e: React.ChangeEvent<{
            name?: string | undefined;
            value: unknown;
          }>) => handleChange(String(e.target.value))}
      >
        <MenuItem value="pt-BR">
          <Box display="flex" alignItems="center" gridGap={10}>
            <Avatar src={ptBrLogo} alt="Brasil" />
            <Typography align="center">{t('portuguese')}</Typography>
          </Box>
        </MenuItem>

        <MenuItem value="es">
          <Box display="flex" alignItems="center" gridGap={10}>
            <Avatar src={esLogo} alt="Espanõl" />
            <Typography align="center">{t('espanish')}</Typography>
          </Box>
        </MenuItem>

        <MenuItem value="en">
          <Box display="flex" alignItems="center" gridGap={10}>
            <Avatar src={usLogo} alt="USA" />
            <Typography align="center">{t('english')}</Typography>
          </Box>
        </MenuItem>
        
      </Select>
    </FormControl>
  );
}

export default LanguageSwitcher;
